import axiosInstanceNew from "lib/axiosinstanceNew";

const tutorsMapModal = class {
    constructor() {
        this.baseUrl = "tutors";
}


async get(id=[]) {


  const response = await axiosInstanceNew.post(`${this.baseUrl}`,id);
  return response.data;
}
  async temget(e) {

    return (
      await (axiosInstanceNew.get(`${this.baseUrl}?enquiry_id=${e}`))).data;
    
  }

}
export default new tutorsMapModal();
